import { useEffect, useState } from 'react'

const useKeyPress = (targetKey: string): boolean => {
  const [keyPressed, setKeyPressed] = useState(false)

  const downHandler = (e: React.KeyboardEvent): void => {
    e.stopPropagation()
    if (e.key === targetKey) {
      setKeyPressed(true)
    }
  }

  const upHandler = (e: React.KeyboardEvent): void => {
    e.stopPropagation()
    if (e.key === targetKey) {
      setKeyPressed(false)
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', downHandler)
    document.addEventListener('keyup', upHandler)
    return () => {
      document.removeEventListener('keydown', downHandler)
      document.removeEventListener('keyup', upHandler)
    }
  }, [])

  return keyPressed
}

export default useKeyPress
